import React, { Component } from "react";
import loaderPic from "./../assets/images/garden-loader.gif";

export default class Loaders extends Component {
  render() {
    const loaderStyle = {
      position: "fixed",
      zIndex: 9999,
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(255, 255, 255, 0.65)",
    };

    const loaderSmallStyle = {
      ...loaderStyle,
      width: "100%",
      height: "100%",
    };

    const loaderImageStyle = {
      width: "170px", 
      height: "100px", 
    };

    return (
      <>
        {this.props.loader ? null : (
          <div
            style={this.props.classType === "small" ? loaderSmallStyle : loaderStyle}
          >
            <img src={loaderPic} alt="loading..." style={loaderImageStyle} />
          </div>
        )}
      </>
    );
  }
}
